export const SET_LINES_DATA = 'SET_LINES_DATA';
export const SET_SECTIONS_DATA = 'SET_SECTIONS_DATA';
export const SET_PERIOD_TOTALS = 'SET_PERIOD_TOTALS';

const initialState = {
    EfficiencyLinesData: {},
    EfficiencySectionsData: {},
    periodTotals: {},
};

export const setLinesData = (linesData) => ({
    type: SET_LINES_DATA,
    payload: linesData,
});
export const setSectionsData = (sectionsData) => ({
    type: SET_SECTIONS_DATA,
    payload: sectionsData,
});
export const setPeriodTotals = (periodTotals) => ({
    type: SET_PERIOD_TOTALS,
    payload: periodTotals,
});

export const getEfficiencyLinesData = (state) =>
    state.efficiency.EfficiencyLinesData;

export const getEfficiencySectionsData = (state) =>
    state.efficiency.EfficiencySectionsData;

export const getEfficiencyReportData = (state) => ({
    linesData: state.efficiency.EfficiencyLinesData,
    sectionsData: state.efficiency.EfficiencySectionsData,
});

export const getPeriodTotals = (state) => state.efficiency.periodTotals;

export const EfficiencyReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LINES_DATA: {
            return { ...state, EfficiencyLinesData: action.payload };
        }
        case SET_SECTIONS_DATA: {
            return { ...state, EfficiencySectionsData: action.payload };
        }
        case SET_PERIOD_TOTALS: {
            return { ...state, periodTotals: action.payload };
        }
        default:
            return state;
    }
};
